import { css, cx } from "@emotion/css";
import ImageWithPlaceholder from "components/common/ImageWithPlaceholder";
import { TrackTitleContent } from "components/Widget/TrackTitleContent";
import React from "react";
import { Link } from "react-router-dom";
import { getTrackUrl } from "utils/artist";

import { bp } from "../../constants";

export const TrackArtistLinks: React.FC<{
  track: Track;
  target?: "_blank";
  fullLink?: boolean;
}> = ({ track, target, fullLink }) => {
  const artists: { artistId?: string | number; artistName?: string }[] =
    track.trackArtists?.filter((artist) => artist.isCoAuthor) ?? [];

  if (artists.length === 0) {
    artists.push({
      artistId: track.trackGroup.artist.urlSlug ?? track.trackGroup.artistId,
      artistName: track.trackGroup.artist.name,
    });
  }

  return artists.map((artist, index) => (
    <React.Fragment key={artist.artistName}>
      {artist.artistId ? (
        <>
          {fullLink ? (
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={`${import.meta.env.VITE_CLIENT_DOMAIN}/${artist.artistId}`}
            >
              {artist.artistName}
            </a>
          ) : (
            <Link
              to={`/${artist.artistId}`}
              className="web-scrobbler-artist"
              target={target}
              rel={target === "_blank" ? "noopener noreferrer" : undefined}
            >
              {artist.artistName}
            </Link>
          )}
        </>
      ) : (
        artist.artistName
      )}
      {index < artists.length - 1 && ", "}
    </React.Fragment>
  ));
};

const PlayingTrackDetails: React.FC<{
  currentTrack: Track;
  byLineEnd?: React.ReactNode;
}> = ({ currentTrack, byLineEnd }) => {
  return (
    <div
      className={css`
        width: 40%;
        flex: 40%;
        display: flex;
        align-items: center;
        gap: 0.5rem;

        margin-right: 1rem;
        margin-left: 1rem;
        margin-bottom: 0.25rem;
        padding-top: 0.35rem;

        a {
          text-decoration: none;
        }

        @media (max-width: ${bp.small}px) {
          margin-right: 0.5rem;
          margin-left: 0.5rem;
        }
      `}
    >
      <ImageWithPlaceholder
        src={currentTrack?.trackGroup.cover?.sizes?.[120]}
        size={48}
        square
        objectFit="contain"
        alt=""
        className={cx(
          "web-scrobbler-track-art",
          css`
            width: 48px;
            height: 48px;
            flex-basis: 48px;
          `
        )}
      />
      <div
        className={css`
          max-width: 80%;
          flex: 80%;
          display: flex;
          flex-direction: column;
          min-width: 0;
          @media (max-width: ${bp.small}px) {
            max-width: 70%;
            flex: 70%;
          }
        `}
      >
        <TrackTitleContent
          track={currentTrack}
          embeddedInMirlo={false}
          combineFromAndBy
          useTrackArtistLinks
          titleLinkTo={
            currentTrack.trackGroup.isHiddenTrackGroupForSongDrafts
              ? undefined
              : getTrackUrl(
                  currentTrack.trackGroup.artist,
                  currentTrack.trackGroup,
                  currentTrack
                )
          }
          byLineEnd={byLineEnd}
          foldByLineAtSm
          compactTitle
        />
      </div>
    </div>
  );
};

export default PlayingTrackDetails;
